import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';


// DEFAULT COMPONENT
const ModalPortableContainer = (props) => {
  const ComponentModal = props.ComponentModal;
  let options = {};
  if (js_utils.is_object(props.options)) {
    options = props.options;
  }

  /*
  if (modal.modalContent !== false) {
    jsx = (
      <div className={'modal-bottom-sheet-koglovo__overlay'}>
        <div className="modal-scrollable">
          <div className="fix-center-flex">
            <div className="flex-1"></div>

            <div className="modal">
              {
                without_x_button !== true && (
                  <>
                    <div className="modal-close" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                    <div className="modal-close modal-close--left" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                  </>
                )
              }
              {
                reloading === false ? (modal.modalContent) : (jsxTempReloading)
              }
            </div>

            <div className="flex-1"></div>
          </div>
        </div>
      </div>
    );
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
  */

  /*
  let jsxModalContent = null;
  if (props.children !== false) {
    jsxModalContent = props.children;
  }
  */

  return (
    <ComponentModal
      opened={props.opened}
      cbClose={props.cbClose}
      options={options}
    >{(props.children !== false && props.children) ? (props.children) : (null)}</ComponentModal>
  );
};

export default ModalPortableContainer;